import React from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import Textfield from '@bt-react/components/Textfield'
import componentStyles from './SearchBox.module.scss'
import debounce from 'lodash/debounce'

class SearchBox extends React.PureComponent {

  constructor (props) {

    super(props)
    this.handleChange = debounce(props.onChange, 500)

  }

  render () {

    return <div className={componentStyles['search-box']} data-bdd="communication-search">
      <Textfield
        placeholder="Search"
        data-bdd="search-box"
        onChange={this.handleChange}
      />
      <Icon name={IconType.iconName.search} />
    </div>

  }

}

export default SearchBox
